export enum DistributionType {
  DEADLINE = "DEADLINE",
  INSTANT = "INSTANT",
}
